import { useCallback, useState } from 'react';
import {
  FormContainer,
  FormItemContainer,
  HeroLogo,
  Label,
  TextInput,
  Button,
  IconButton,
  VisibilityIcon,
  VisibilityOffIcon,
} from '../../components';
import { useNavigate } from 'react-router-dom';

import { useValidation, useSubmitLogin } from './hooks';
import { friendlyErrorMapping } from '../../utils';
import { Alert, Stack } from '@mui/material';

export const UserLogin = () => {
  const navigate = useNavigate();
  const { submitLogin } = useSubmitLogin();
  const { validate, validationErrors: formError } = useValidation();

  const [visiblePassword, setVisiblePassword] = useState(false);
  const [submitFailError, setSubmitFailError] = useState(null);

  const onRegisterClick = useCallback(() => {
    navigate('/user/register');
  }, [navigate]);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = useCallback(
    (value, name) => {
      setFormData((prev) => {
        const newFormData = {
          ...prev,
          [name]: value,
        };
        validate(newFormData, name);
        return newFormData;
      });
      setSubmitFailError(null);
    },
    [validate]
  );

  const handleVisiblePasswordChange = useCallback(() => {
    setVisiblePassword((prev) => !prev);
  }, []);

  const onSubmit = useCallback(() => {
    if (submitFailError) return;
    const { isValid } = validate(formData);
    if (isValid) {
      submitLogin(formData)
        .then(() => navigate('/user/dashboard'))
        .catch((error) => {
          const code = error.code;
          console.log(JSON.stringify(error), error.code);
          setSubmitFailError(friendlyErrorMapping[code]);
        });
    }
  }, [formData, navigate, submitFailError, submitLogin, validate]);

  return (
    <FormContainer>
      <HeroLogo />
      <Stack gap="20px">
        {submitFailError && (
          <Alert severity="error">登录失败，{submitFailError}</Alert>
        )}
        <FormItemContainer>
          <Label isRequired>邮箱</Label>
          <TextInput
            name="email"
            value={formData.email}
            onChange={handleChange}
            error={formError?.email}
          />
        </FormItemContainer>
        <FormItemContainer>
          <Label isRequired>密码</Label>
          <TextInput
            name="password"
            value={formData.password}
            onChange={handleChange}
            type={visiblePassword ? 'text' : 'password'}
            endAdornment={
              <IconButton onClick={() => handleVisiblePasswordChange()}>
                {visiblePassword ? (
                  <VisibilityIcon size="20px" />
                ) : (
                  <VisibilityOffIcon size="20px" />
                )}
              </IconButton>
            }
            error={formError?.password}
          />
        </FormItemContainer>
        <Button block onClick={onSubmit}>
          登录
        </Button>
        <Button block variant="secondary" onClick={onRegisterClick}>
          注册
        </Button>
      </Stack>
    </FormContainer>
  );
};
